import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { MobileBar } from "@/components/MobileBar";
import { IntroProvider } from "@/components/Intro";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import ServicePage from "@/pages/ServicePage";
import Geschaeftskunden from "@/pages/Geschaeftskunden";
import UeberUns from "@/pages/UeberUns";
import Kontakt from "@/pages/Kontakt";
import Legal from "@/pages/Legal";
import LocationPage from "@/pages/LocationPage";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout() {
  useLenis();
  return (
    <>
      <ScrollToTop />
      <Nav />
      <main id="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leistungen" element={<Leistungen />} />
          <Route path="/leistungen/:slug" element={<ServicePage />} />
          <Route path="/privatreinigung" element={<ServicePage slug="privatreinigung" />} />
          <Route path="/umzugsreinigung" element={<ServicePage slug="umzugsreinigung" />} />
          <Route path="/baureinigung" element={<ServicePage slug="baureinigung" />} />
          <Route path="/fensterreinigung" element={<ServicePage slug="fensterreinigung" />} />
          <Route path="/gartenbau-pflege" element={<ServicePage slug="gartenbau-pflege" />} />
          <Route path="/geschaeftskunden" element={<Geschaeftskunden />} />
          <Route path="/ueber-uns" element={<UeberUns />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/impressum" element={<Legal kind="impressum" />} />
          <Route path="/datenschutz" element={<Legal kind="datenschutz" />} />
          <Route path="/standorte/:slug" element={<LocationPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <MobileBar />
      <Toaster position="bottom-center" toastOptions={{ className: "font-sans" }} />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <IntroProvider>
        <Layout />
      </IntroProvider>
    </BrowserRouter>
  );
}
